// removed by extract-text-webpack-plugin
module.exports = {"private-invitation":"private-invitation-info__private-invitation__qpIDs"};


//////////////////
// WEBPACK FOOTER
// ./src/components/details/private-invitation-info.scss
// module id = 1319
// module chunks = 1